import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Rows = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 12px 24px;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
`;

export const Label = styled.div`
    font-size: 12px;
    color: ${colors.fieldLabel};
`;

export const Value = styled.div`
    color: ${colors.textPrimary};
    overflow-wrap: anywhere;
`;

export const PaidValue = styled(Value)<{ $tone: "paid" | "unpaid" | "refunded" }>`
    color: ${(props) => {
        if (props.$tone === "paid") return colors.success;
        if (props.$tone === "refunded") return colors.danger;
        return colors.amber;
    }};
`;

export const Links = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 16px;
`;

export const ReceiptLink = styled.a`
    color: ${colors.primary};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const Actions = styled.div`
    display: flex;
    margin-top: 20px;
`;
